import React from 'react';
import { Button, Input } from 'common/components';
import { COGNITO_PASSWORD_HINT } from 'common/constants';
import { NewPasswordChallengeFormProps } from '../Login.types';
import styles from '../Login.module.scss';

const NewPasswordChallengeForm: React.FC<NewPasswordChallengeFormProps> = ({
    email,
    passwordChallengeDone,
    newPassword,
    confirmPassword,
    error,
    isLoading,
    onNewPasswordChange,
    onConfirmPasswordChange,
    onSubmit,
    onBack,
}) => {
    return (
        <form onSubmit={onSubmit} className={styles.loginForm}>
            <p className={styles.demoText} style={{ margin: 0 }}>
                Signed in as <strong>{email.trim().toLowerCase()}</strong>.
                {passwordChallengeDone
                    ? ' Password saved. Retry to finish signing in.'
                    : ' Set a lasting password to continue.'}
            </p>
            {!passwordChallengeDone && (
                <>
                    <Input
                        label='New password'
                        type='password'
                        placeholder='Enter a new password'
                        value={newPassword}
                        onChange={(e) => onNewPasswordChange(e.target.value)}
                        disabled={isLoading}
                        required
                    />
                    <Input
                        label='Confirm new password'
                        type='password'
                        placeholder='Confirm new password'
                        value={confirmPassword}
                        onChange={(e) => onConfirmPasswordChange(e.target.value)}
                        disabled={isLoading}
                        required
                    />
                    <p className={styles.demoText} style={{ margin: 0, fontSize: '0.85rem' }}>
                        {COGNITO_PASSWORD_HINT}
                    </p>
                </>
            )}
            {error && <p className={styles.loginError}>{error}</p>}
            <Button type='submit' variant='primary' disabled={isLoading} size='md'>
                {isLoading
                    ? passwordChallengeDone
                        ? 'Signing in…'
                        : 'Saving…'
                    : passwordChallengeDone
                      ? 'Continue signing in'
                      : 'Set password and continue'}
            </Button>
            <Button type='button' variant='ghost' disabled={isLoading} onClick={onBack}>
                Back to sign in
            </Button>
        </form>
    );
};

export default NewPasswordChallengeForm;
